import {DependencyInjectId} from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import { type AxiosResponse } from "axios";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import { MyCourseListModel } from "~~/package/mapper/course/model/MyCourseListModel";
import { CourseDetailModel } from "~~/package/mapper/course/model/CourseDetailModel";
import type CourseRecentlyResponse from "~~/package/apis/course/response/CourseRecentlyResponse";
import type CustomResponse from "~~/package/types/ResponseType";

export default class CourseApi {

  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getCourseDetail(id: number, lang: string): Promise<AxiosResponse<CustomResponse<CourseDetailModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<CourseDetailModel>>>("/v2/course/"+id, undefined, true, lang);
  }

  public getCourseRecently(lang: string): Promise<AxiosResponse<CustomResponse<CourseRecentlyResponse>>> {
    return this.http.get<AxiosResponse<CustomResponse<CourseRecentlyResponse>>>("/v2/course/recently", undefined, true, lang);
  }

  public getCourseMyList(isRecentCourse: boolean, lang: string): Promise<AxiosResponse<CustomResponse<MyCourseListModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<MyCourseListModel[]>>>("/v2/course/list/my", {isRecentCourse}, true, lang);
  }

  public startCourse(id: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>,{[key: string]: number}>(`/course/start/${id}`, {id},true);
  }

  public finishedOnBoarding(): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.put<AxiosResponse<CustomResponse<boolean>>, undefined>('/course/learning/user/onBoarding',undefined,true);
  }
}
